import { z } from 'zod'
import { Bearing, Metres, MetresPerSecond, Vec2 } from './primitives.js'

/**
 * Where a listener is and which way they face, in world-frame metres.
 *
 * `source` is part of the contract rather than a client detail: simulated and
 * replayed poses must stay visible in diagnostics and excluded from creator
 * analytics, so a desk test can never be mistaken for a real visit.
 */
export const PoseSource = z.enum(['gps', 'simulated', 'manual', 'replay'])
export type PoseSource = z.infer<typeof PoseSource>

export const Pose = z.object({
  /** Epoch milliseconds on the server-corrected clock. */
  t: z.number().finite(),
  position: Vec2,
  elevationM: z.number().finite().optional(),
  headingDeg: Bearing.optional(),
  speedMps: MetresPerSecond.optional(),
  /** Horizontal accuracy radius. Above the world's floor, spatial triggers hold. */
  accuracyM: Metres.optional(),
  source: PoseSource,
})
export type Pose = z.infer<typeof Pose>

/** How the heading was derived, surfaced to the listener and to diagnostics. */
export const HeadingSource = z.enum(['compass', 'courseOverGround', 'manual', 'none'])
export type HeadingSource = z.infer<typeof HeadingSource>
